import { render } from "./SubMain.vue?vue&type=template&id=52ef991d"
import script from "./SubMain.vue?vue&type=script&lang=js"
export * from "./SubMain.vue?vue&type=script&lang=js"

import exportComponent from "/Users/konradmilewski/Projects/AppWorks/janpawelvue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__